(function () {
  'use strict';

  var ITEMS = [
    {
      href: '/collections/monthly-subscription-options',
      src: 'https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_monthly_subscription_box.webp?v=1789340666',
      alt: 'Monthly Subscription Box'
    },
    {
      href: '/collections/show-all-products-by-justsmoke-me?filter.v.price.lte=1',
      src: 'https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_one_pound_or_less.webp?v=1789340697',
      alt: '£1 or Less'
    },
    {
      href: '/collections/special-bundles-offers-by-justsmoke-me',
      src: 'https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_all_bundles.webp?v=1789340678',
      alt: 'All Bundles'
    },
    {
      href: '/collections/cannabis-gifts-for-stoners-by-justsmoke-me',
      src: 'https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_gifts_for_him_her.webp?v=1789340671',
      alt: 'Gifts for Him & Her'
    }
  ];

  function buildRail() {
    var host = document.querySelector('.tt-desktop-header .js-header-roll-host');
    if (!host) return;

    var legacy = host.querySelector('.js-header-art-rail');
    if (legacy) legacy.remove();

    var existing = host.querySelector('#js-tiki-header-rail');
    if (existing) existing.remove();

    var rail = document.createElement('div');
    rail.id = 'js-tiki-header-rail';
    rail.setAttribute('aria-label', 'Featured collections');

    ITEMS.forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'js-tiki-header-link';
      link.href = item.href;
      link.setAttribute('aria-label', item.alt);

      var img = document.createElement('img');
      img.className = 'js-tiki-header-image';
      // 2026-10-04 (RQ-10): intrinsic size (all four are 1086x1448) so the browser reserves the 3:4 box before the
      // image arrives. CSS keeps width:100%;height:auto, so the rendered size is unchanged.
      img.width = 1086;
      img.height = 1448;
      img.src = item.src;
      img.alt = item.alt;
      img.loading = 'eager';
      img.decoding = 'async';

      link.appendChild(img);
      rail.appendChild(link);
    });

    var logo = host.querySelector('.tt-obj-logo');
    if (logo) host.insertBefore(rail, logo);
    else host.insertBefore(rail, host.firstChild || null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildRail, { once: true });
  } else {
    buildRail();
  }
})();
